import { startOfHour, addHours, format } from 'date-fns'

export const nextRun = (interval) => {
  const nRun = startOfHour(new Date())
  const roundUp = addHours(nRun, interval)
  return format(roundUp, 'hh:mm a')
  /* const m = moment(new Date())
  const roundUp = m.minute() || m.second() || m.millisecond() ? m.add(getConfig().PLAN_RATINGS_RUNINTERVAL_HOUR, 'hour').startOf('hour') : m.startOf('hour')
  return moment(roundUp).format('hh:mm a') */
}



// WEBPACK FOOTER //
// ./src/utils/nextRun.js